import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared';
import { RatePlanningDataService } from '../data-services/rate-planning';
import { RatePlanningRoute } from '../indirect-rate/indirect-rate.route';


@NgModule({
    declarations: [],
    providers: [RatePlanningDataService],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [RatePlanningRoute]
        })
    ]
})
export class RatePlanningModule {}
